export default "/static/e388d587241be1eb.svg"